import { useQuery } from "@tanstack/react-query";
import { getGraphToken } from "./API/core.service";
import { INTERVAL } from "../constants/clientTime";

export function useGraphToken() {
  return useQuery({
    queryKey: ["graphToken"],
    queryFn: async () => {
      const data = await getGraphToken();
      return data.token;
    },
    refetchOnWindowFocus: false,
    staleTime: 1 * INTERVAL.HOUR,
  });
}
